import {
  ItemListItemRowData,
  ItemListRowType,
} from "@/components/item-list/types/item-list-row-types";
import { ItemListItemKind } from "@/components/item-list/types/item-list-item-types";
import { generateShortDateString } from "@/domains/date/date";
import { MDSIconKind } from "@/mds";
import { AppStore } from "@/store/AppStore";
import { ListStateObservable } from "@/store/pages/ListStateObservable";
import { SpaceAccountCalendarEventObservable } from "@/store/calendar/space-account-calendar-event/SpaceAccountCalendarEventObservable";
import { DateTime } from "luxon";
import { itemsModule } from "@/modules/items";
import { uuidModule } from "@/modules/uuid";
import { UNTITLED_CALENDAR_EVENT_TITLE } from "@/domains/untitled/untitled";

export const getItemListRowForCalendarEvent = ({
  listState,
  calendarEventObservable,
  store,
}: {
  listState?: ListStateObservable;
  calendarEventObservable: SpaceAccountCalendarEventObservable;
  store: AppStore;
}) => {
  const eventId = calendarEventObservable.id;
  const itemAppearance = itemsModule.resolveAppearance({
    itemId: eventId,
    appStore: store,
  });

  const startTime = calendarEventObservable.startTime
    ? DateTime.fromISO(calendarEventObservable.startTime)
    : null;
  const dateLabel = startTime ? generateShortDateString(startTime) : undefined;
  const associatedNote = calendarEventObservable.associatedNote;

  const row: ItemListItemRowData = {
    type: ItemListRowType.Item,
    key: eventId,
    payload: {
      id: eventId,
      kind: ItemListItemKind.CalendarEvent,
      titleIcon: { kind: MDSIconKind.Calendar },
      appearance: itemAppearance,
      label: calendarEventObservable.primaryLabel || UNTITLED_CALENDAR_EVENT_TITLE,
      onClick: async () => {
        if (!associatedNote) {
          const noteId = uuidModule.generate();
          await store.notes.createNoteUsingCalendarEventId({
            noteId,
            calendarEventId: eventId,
          });
          store.navigation.goToNote({ noteId });
        } else {
          store.navigation.goToNote({ noteId: associatedNote.id });
        }
      },
      dateLabel,
      listState,
    },
  };

  return row;
};
